import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import { RichText } from '@sitecore-jss/sitecore-jss-react';

import { Link } from 'react-router-dom'
import '../../assets/css/0020_objects/0660_obj_products_related_aside.css';

class ObjProductsRelatedAside extends Component {
	render() {
        const { datasProduits } = this.props;

		return (<>{datasProduits && <>
			<div className="obj_products_related_aside">
				<h3 className="t_title">Produits associés</h3>
				
				<ul className="obj_menu_aside_list">
					{ datasProduits.map((datasProduct, index) => (
                        <li key={index} className="menu_aside-item">
                            <Link to={datasProduct.url}>
                                <RichText field={datasProduct.pageTitle.jss}></RichText>
                            </Link>
                        </li>
					))}
				</ul>
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjProductsRelatedAside));